const chainIds = {
	hazama: 1,
	ethereum: 1,
	rinkeby: 4,
	goerli: 5,
	polygon: 137,
	mumbai: 80001,
	astar: 592
}

exports.NetworkInfo = Object.freeze({
	hazama: {
		chainId: `0x${chainIds.hazama.toString(16)}`,
		chainName: 'Hazama Network',
		name: 'Hazama',
		rpcUrls: ['https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161']
	},
	ethereum: {
		chainId: `0x${chainIds.ethereum.toString(16)}`,
		chainName: 'Ethereum Network',
		name: 'Ethereum',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18
		},
		rpcUrls: ['https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161']
	},
	polygon: {
		chainId: `0x${chainIds.polygon.toString(16)}`,
		chainName: 'Polygon Network',
		name: 'Polygon',
		nativeCurrency: {
			name: 'MATIC',
			symbol: 'MATIC',
			decimals: 18
		},
		rpcUrls: ['https://polygon-rpc.com']
	},
	astar: {
		chainId: `0x${chainIds.astar.toString(16)}`,
		chainName: 'Astar Network',
		name: 'Astar',
		nativeCurrency: {
			name: 'ASTR',
			symbol: 'ASTR',
			decimals: 18
		},
		rpcUrls: ['https://rpc.astar.network:8545'],
		blockExplorerUrls: ['https://astar.subscan.io/'],
	},
	
	rinkeby: {
		chainId: `0x${chainIds.rinkeby.toString(16)}`,
		chainName: 'Rinkeby Network',
		name: 'Rinkeby',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18
		},
		rpcUrls: ['https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161']
	},
	goerli: {
		chainId: `0x${chainIds.goerli.toString(16)}`,
		chainName: 'Goerli Network',
		name: 'Goerli',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18
		},
		rpcUrls: ['https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161']
	},
	mumbai: {
		chainId: `0x${chainIds.mumbai.toString(16)}`,
		chainName: 'Mumbai Network',
		name: 'Mumbai',
		nativeCurrency: {
			name: 'MATIC',
			symbol: 'MATIC',
			decimals: 18
		},
		rpcUrls: ['https://matic-mumbai.chainstacklabs.com']
	},
})

exports.getRpcUrlsByNetWork = (network) => exports.NetworkInfo[network]?.rpcUrls?.[0] || ''